<template>
    <router-view />
</template>
<script>
export default {name: 'LkIndex'};
</script>
<style scoped></style>
